import DeleteCartItem from './DeleteCartItem';

export default DeleteCartItem;



// WEBPACK FOOTER //
// ./src/components/shared/DeleteCartItem/index.js